<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Anise"><div class="titlepage"><div><div><h1 class="title"><a id="d0e88" xmlns:saxon="http://icl.com/saxon"></a>Anise
                    </h1></div></div></div><p><span class="emphasis"><em>Pimpinella
                    anisum</em></span></p><p class="underline">“For the dropsie, fill an old cock
                with Polipody and Aniseeds </p><p class="underline">and seethe him well, and drink
                the broth.” </p><p class="attribution">—William Langham, <span class="emphasis"><em>The Garden of Health,</em></span> 1633 </p><p><span class="dropcap">A</span>nise, also known as anise seed, pimpinel, and sweet cumin, is a member
                of the parsley family and, like many <span class="emphasis"><em>umbellifers</em></span>, is thought to be anciently native to Egypt,
                Greece, and parts of the southern Mediterranean. According to excavated texts, anise
                has been cultivated in Egypt since at least 2000 B.C., the flavorful “seeds” having
                been employed as a diuretic, a digestive aid, and to relieve toothache. Anise is
                mentioned in the seventeenth-century-B.C. works of Hammurabi, the sixth king of
                Babylon and author of the <span class="emphasis"><em>Code of Hammurabi,</em></span>
                one of the first legal treatises in recorded history, and it is also known that
                Charlemagne adored this fragrant herb and planted it extensively in his gardens at
                Aquisgrana between A.D. 800 and 814. Anise was known to British herbalists by the
                fourteenth century A.D. and, according to Mrs. Grieve, was being cultivated in Great
                Britain by the mid-sixteenth century, when it was also introduced into South America
                by the Spanish conquistadors. The <span class="emphasis"><em>Pimpinella</em></span>
                in anise’s botanical name derives from the Latin <span class="emphasis"><em>dipinella,</em></span> or “twice pinnate,” in reference to its leaf
                form, and because of its pungent, licorice sweetness, anise saw broad medicinal
                application across all cultures it touched, but particularly for respiratory and
                digestive ailments. </p><p>Hippocrates, father of modern medicine, recommended anise
                for respiratory issues in the fourth century B.C., and the Greek botanist
                Dioscorides wrote in the first century A.D. that anise “warms, dries, and dissolves”
                everything from an aching stomach and a sluggish digestion to excessive “winde” and
                a stinking breath. John Gerard recommended it in his <span class="emphasis"><em>Herball</em></span> of 1636 for “the yeoxing or hicket [hiccup]” as
                well as “strengthening the coitus,” and in 1763 Christopher Sauer maintained that it
                “removes chill from the chest” and “staves off coughing fits.” The breath-sweetening
                employment was also lauded by the British apothecary William Turner, who reported in
                1551 that “anyse maketh the breth sweter and swageth payne.” </p><p>Interestingly,
                unlike many early herbal claims, most of those attached to anise are surprisingly
                smack on the money. We know now that anise seeds contain healthy doses of vitamin B,
                calcium, iron, magnesium, and potassium, as well as athenols, which aid in
                digestion, calm intestinal spasms, and reduce gas. A tisane made of anise has also
                proven effective in calming both coughs and chronic asthma, and, of course, anise is
                the main flavoring ingredient in those potent nectars anisette, pastis, and
                absinthe, the latter of which will pretty much calm anything into submission.
                </p><p>Anise is also a very pretty plant, with bright green coriander-like foliage
                and lovely, diminutive white-and-yellow flowers held in feathery umbels, the whole
                of it growing to about 18 inches. </p><div class="mediaobject" title="Photo of anise."><img alt="Photo of anise." src="images/Anise.jpg"/><div class="caption"><p>Anise</p></div></div><p>Anise seeds are actually the fruit of
                the anise plant; when dried, they are transformed into those familiar gray/brown,
                longitudinally ribbed seeds habitually positioned as a digestif by the cash register
                in your favorite Indian restaurant. Anise is an annual herb and needs a longish,
                hot, dry season to seed successfully, so, in cooler climes, it is advisable to start
                seeds in pots indoors in March and set them out when the soil is well warmed up.
                Otherwise, sow seed in situ in dry, light soil and a sunny spot early in April,
                thinning the plants to about a foot apart. When threshed out, anise seeds are easily
                dried in trays and jarred for future use. In ancient Rome, wedding celebrations
                customarily ended with an anise-scented Mustacae cake to aid digestion (and, one
                assumes, “strengthen the coitus”), so why not create your own festivity by mixing a
                handful of anise seeds into your favorite pound cake recipe? </p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?72aeab70